import React from "react";
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";

const NotFound=()=>{
    return(
        <><NavBar /><div className="pages">
<h1>Not Found</h1>
        </div><Footer /></>
    )
}
export default NotFound;